module.exports = __webpack_public_path__ + "img/gunlock.3355a51d.png";